var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("admin-dashboard-widgets"),
      _vm._v(" "),
      _c("div", { staticClass: "row dashboard-block" }, [
        _vm.$vlastMode && _vm.$showDepartmentField
          ? _c(
              "div",
              { staticClass: "col-xs-12" },
              [
                _c("scatterplot", {
                  staticClass: "chart-card",
                  attrs: {
                    uniqueName: "total_hours_per_player",
                    showBrush: true,
                    name: "hours_completed_per_" + _vm.$starLabel,
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.$vlastMode && _vm.$showDepartmentField
          ? _c(
              "div",
              { staticClass: "col-xs-12" },
              [
                _c("bar-chart", {
                  staticClass: "chart-card",
                  attrs: {
                    uniqueName: "booking_request_by_opportunity_type",
                    showBrush: false,
                    name: "booking_requests_by_summary",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.$vlastMode && _vm.$showDepartmentField
          ? _c(
              "div",
              { staticClass: "col-xs-12" },
              [
                _c("bar-chart", {
                  staticClass: "chart-card",
                  attrs: {
                    uniqueName: "total_hours_per_department",
                    showBrush: false,
                    name: "hours_per_department",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-xs-12" },
          _vm._l(this.getDateTimeChartsToShow(), function (chartName) {
            return _c("datetime-line-chart", {
              key: chartName,
              staticClass: "chart-card",
              attrs: {
                uniqueName: chartName,
                type: "single",
                showBrush: false,
                channelData: false,
                name: chartName,
              },
            })
          }),
          1
        ),
      ]),
      _vm._v(" "),
      _vm.$chatsModuleEnabled
        ? _c("div", { staticClass: "dashboard-block" }, [
            _c("h2", { staticClass: "has-button" }, [
              _vm._v(
                "\n      Active Chats\n      –\n      " +
                  _vm._s(_vm.lists.active_threads_count) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _vm.haveNoActiveThreads
              ? _c("div", { staticClass: "text-center alert alert-default" }, [
                  _vm._v("\n      There are no active chats\n    "),
                ])
              : _c(
                  "ul",
                  { staticClass: "list-items" },
                  _vm._l(_vm.activeThreads, function (thread) {
                    return _c("thread-list-item", {
                      key: thread.id,
                      attrs: { thread: thread, booking: thread.booking },
                    })
                  }),
                  1
                ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "text-right" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-info",
                    staticStyle: { "letter-spacing": "2px" },
                    attrs: { to: { name: "threads.index" } },
                  },
                  [_vm._v("View All")]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "dashboard-block" }, [
        _c("h2", { staticClass: "has-button" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("Requests")) +
              " Ending Soon\n      –\n      " +
              _vm._s(_vm.lists.expiring_requests_count) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _vm.haveNoExpiringRequests
          ? _c("div", { staticClass: "text-center alert alert-default" }, [
              _vm._v(
                "\n      There are no " +
                  _vm._s(_vm.$t("requests")) +
                  " ending soon.\n    "
              ),
            ])
          : _c(
              "ul",
              { staticClass: "list-items" },
              _vm._l(_vm.expiringRequests, function (booking) {
                return _c("admin-dashboard-expiring-requests-list-item", {
                  key: booking.id,
                  attrs: { booking: booking },
                })
              }),
              1
            ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text-right" },
          [
            _c(
              "router-link",
              {
                staticClass: "btn btn-info",
                staticStyle: { "letter-spacing": "2px" },
                attrs: { to: { name: "requests.index" } },
              },
              [_vm._v("View All")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "dashboard-block" }, [
        _c("h2", { staticClass: "has-button" }, [
          _vm._v(
            "\n      Pending " +
              _vm._s(_vm.$t("Requests")) +
              "\n      –\n      " +
              _vm._s(_vm.lists.vetting_requests_count) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _vm.haveNoVettingRequests
          ? _c("div", { staticClass: "text-center alert alert-default" }, [
              _vm._v(
                "\n      There are no vetting " +
                  _vm._s(_vm.$t("requests")) +
                  ".\n    "
              ),
            ])
          : _c(
              "ul",
              { staticClass: "list-items" },
              _vm._l(_vm.vettingRequests, function (booking) {
                return _c("admin-dashboard-vetting-requests-list-item", {
                  key: booking.id,
                  attrs: { booking: booking },
                })
              }),
              1
            ),
        _vm._v(" "),
        _c("div", { staticClass: "text-right" }, [
          _c(
            "h2",
            [
              _c(
                "router-link",
                {
                  staticClass: "btn btn-info",
                  staticStyle: { "letter-spacing": "2px" },
                  attrs: { to: { name: "vetting.index" } },
                },
                [_vm._v("View All")]
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "dashboard-block" }, [
        _c("h2", { staticClass: "has-button" }, [
          _vm._v(
            "\n      Bookings Not Marked Complete\n      –\n      " +
              _vm._s(_vm.lists.bookings_not_completed_count) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _vm.haveNoBookingsNotCompleted
          ? _c("div", { staticClass: "text-center alert alert-default" }, [
              _vm._v(
                "\n      There are no bookings not marked as complete.\n    "
              ),
            ])
          : _c(
              "ul",
              { staticClass: "list-items" },
              _vm._l(_vm.bookingsNotCompleted, function (booking) {
                return _c("admin-dashboard-bookings-not-completed-list-item", {
                  key: booking.id,
                  attrs: { booking: booking },
                })
              }),
              1
            ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text-right" },
          [
            _c(
              "router-link",
              {
                staticClass: "btn btn-info",
                staticStyle: { "letter-spacing": "2px" },
                attrs: { to: { name: "bookings.index" } },
              },
              [_vm._v("View All")]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }